export const ATUALIZADO = 'Indicação atualizada'
export const CADASTRADO = 'Indicação adicionada'
export const NAO_ENCONTRADO = 'Não foram encontradas indicações em aberto'
export const NAO_ENCONTRADO_FILTRO = 'Não há indicações com esse filtro'
